// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__TqESp","control":"Auth_control__etlcY"};